import { ReactNode } from 'react'

import { cn, INTERACTIVE_ROW_HOVER_BG_MD } from '~/utils/tailwind-utils'

// Shared row skeleton for the transactions feed; callers fill the slots.
export const TransactionFeedItemShell = ({
  onClick,
  isHighlighted = false,
  icon,
  title,
  subtext,
  trailing,
  actions,
}: {
  onClick: () => void
  isHighlighted?: boolean
  icon: ReactNode
  title: ReactNode
  subtext: ReactNode
  trailing: ReactNode
  actions: ReactNode
}) => {
  return (
    <div
      className={cn(
        'group flex w-full cursor-pointer items-center justify-between rounded-xl px-0 py-3 md:p-3',
        INTERACTIVE_ROW_HOVER_BG_MD,
        {
          'bg-surface-hover': isHighlighted,
        },
      )}
      onClick={onClick}
    >
      <div className="flex w-full min-w-0 shrink flex-grow items-start space-x-4 text-base md:space-x-6">
        <div className="flex-shrink-0 pt-1">{icon}</div>
        <div className="flex w-full min-w-0 justify-between">
          <div className="flex w-full min-w-0 flex-col gap-0.5">
            {title}
            {subtext}
          </div>
          {trailing}
        </div>
      </div>
      {actions}
    </div>
  )
}
